import clsx from "clsx"
import type { AriaRole } from "react"

import type { SX } from "../../theme"
import styles from "./Line.module.css"

export interface LineProps {
  color: "grey" | "green" | "amber" | "purple"
  role?: AriaRole
  thickness?: 2 | 4
  sx?: SX
}

export function Line(props: LineProps) {
  const { color, role = "status", thickness = 4, sx } = props

  return (
    <div
      role={role}
      className={clsx(
        styles.line,
        styles[color],
        styles[`thickness-${thickness}`],
      )}
      style={sx}
    />
  )
}
